import { render, staticRenderFns } from "./no-video-layout-support.vue?vue&type=template&id=59931b01&scoped=true"
import script from "./no-video-layout-support.vue?vue&type=script&lang=js"
export * from "./no-video-layout-support.vue?vue&type=script&lang=js"
import style0 from "./no-video-layout-support.vue?vue&type=style&index=0&id=59931b01&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59931b01",
  null
  
)

export default component.exports